<template>
  <modal :show.sync="modalEdit">
    <h4 slot="header" class="title title-up">{{ $t("app.buttons.edit") }} {{ $t("app.modules.product_feature.single") }}</h4>
    <ValidationObserver ref="formEdit" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(editRow)">

        <div class="row">
          <b>{{ $t("app.translations") }}</b>
          <div
            class="col-sm-12"
            v-for="(lang, index) in item.traduccion"
            :key="lang.Idiomas_idIdioma"
          >
            <b>{{ lang.idioma.idioma }}</b>

            <fg-input
              type="text"
              name="minLength"
              :label="$t('app.modules.product_feature.headers.feature')"
              v-model="item.traduccion[index].nombreAtributo"
            >
            </fg-input>

            <el-select
              v-model="item.traduccion[index].valorAtributo"
              multiple
              filterable
              allow-create
              :placeholder="$t('app.modules.product_feature.headers.values')">
            </el-select>

          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 form-group has-label">
            <div class="row">
              <label style="margin-left: 15px">{{ $t("app.general.state") }}</label>
            </div>
            <template>
              <n-switch v-model="item.activo">
                <i class="now-ui-icons ui-1_check" slot="on"></i>
                <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
              </n-switch>
            </template>
          </div>
        </div>
        <div
          slot="footer"
          style="margin-top: 10px; padding-top: 20px;border-top: outset;"
          class="text-right"
        >
          <n-button class="pull-left btn-secondary" @click.native="cancelEdit()"
            >{{ $t("app.buttons.cancel") }}</n-button
          >
          <n-button native-type="submit" type="primary">{{ $t("app.buttons.save") }}</n-button>
        </div>
      </form>
    </ValidationObserver>
  </modal>
</template>
<script>
import { mapState } from "vuex";
export default {
  components: {},
   computed: {
    ...mapState(["user", "availableLangs"])
  },
  created() {
    this.item.usuarios_idUsuario = this.user.idUsuario;

    this.item.traduccion = this.availableLangs.map((lang) => ({
      Idiomas_idIdioma: lang.idIdioma,
      idioma: lang.idioma,
      nombreAtributo: "",
      valorAtributo: ""
    }));
  },
  data() {
    return {
        item: {
          idcaracteristicasProducto: 0,
          activo: true,
          usuarios_idUsuario: 0,
          accion: 'editar',
          Iidioma: "",
          fecha:  new Date(),
          traduccion: []
        },
      switches: {
        withIconsOn: true
      },
      minLength: "",
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      },
      modalEdit: false
    };
  },
  mounted() {
    EventBus.$on("productocaracteristica-edit",  item => {
      this.item = JSON.parse(JSON.stringify(item));

      for (let trad of this.item.traduccion){
        trad.Iidioma = trad.idioma.idioma;
        trad.valorAtributo = this.getOpts(trad.valorAtributo);
      }

      this.$swal.fire({
        title: "Por favor espera",
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      this.$swal.close();
      this.modalEdit = true;
    });
  },
  methods: {
    cancelEdit() {
      this.modalEdit = false;
      this.$refs.formEdit.reset();
    },
    async editRow() {
      let errors = 0;
      this.item.traduccion.forEach(t => {
        if(!!!t.nombreAtributo){
          this.notifyMessage("danger", this.$t("app.modules.product_feature.message.error_feature_required") + ": " + t.Iidioma);
          errors++;
        }
      });

      this.item.traduccion.forEach(t => {
        if(t.valorAtributo.length === 0){
          this.notifyMessage("danger", this.$t("app.modules.product_feature.message.error_value_required") + ": " + t.Iidioma);
          errors++;
        }
      });

      for (let lang of this.item.traduccion) {
        for (let l of this.item.traduccion) {
          if(lang.valorAtributo.length !== l.valorAtributo.length){
            this.notifyMessage("danger", this.$t("app.modules.product_feature.message.error_value_incomplete"));
            errors++;
            return;
          }
        }
      }

      if(errors > 0) return;

      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      for (let lang of this.item.traduccion) {
        lang.valorAtributo = this.generateJson(lang.valorAtributo);
      }

      await this.$http
        .put(route("CaracteristicasProducto/updateCaratacteristicasProducto"), this.item)
        .then(
          async response => {
            if (response.body.code === 200) {
              this.notifyMessage("success", this.$t("app.promps.save_success"));
              this.cancelEdit();
              EventBus.$emit("reload-items");
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});

      this.$swal.close();
    },
    getVals(valor){
      var miarray = [];
      var jsonar = JSON.parse(valor);
      for(let prop in jsonar){
        miarray.push({"label": jsonar[prop], "value": jsonar[prop]});
      }
      return miarray;
    },
    getOpts(valor){
      var miarraydos = [];
      var jsonar = JSON.parse(valor);
      for(let prop in jsonar){
        miarraydos.push(jsonar[prop]);
      }
      return miarraydos;
    },
    generateJson(value)
    {
      var i;
      var elementos = "";
      for (i = 0; i<value.length; i++){
        if(i == (value.length-1)){
          elementos+= '"'+i+'":"' +value[i]+'"';
        } else{
          elementos+= '"'+i+'":"' +value[i]+'",';
        }
      }
      return '{'+ elementos +'}';
    }
  }
};
</script>
<style>
.extended-forms .el-select {
  width: 100%;
  margin-bottom: 30px;
}
.card .alert {
  position: relative !important;
  width: 100%;
}

.modal-content .modal-header {
  padding-bottom: 24px;
  box-shadow: 0px 2px 5px 0px #00000021;
}

.modal-content .modal-body + .modal-footer {
  padding-top: 20px !important;
  background-color: #efefefb3;
}
</style>
